module.exports = __webpack_public_path__ + "2b8d7924a1050cead1724a8bf7407335.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1088
// module chunks = 0